import axios from 'axios';
import Config from './Config';
import { getShopifySessionToken } from './shopify/appBridge';

axios.defaults.withCredentials = true;



const pingAPI = (path, type, body, signal, headers) => {
    // console.log(Config.BASE_URL)
    // console.log(path)
    // console.log(type)
    // console.log(body)
    const responsePromise = new Promise((resolve, reject) => {

    switch (type) {
        case 'GET':
            console.log(Config.BASE_URL);
            console.log(path);
            axios.get(Config.BASE_URL + path, {
                    params: body,
                    signal,
                    headers
                }
            ).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
            break;
        case 'POST':
            // console.log(Config.BASE_URL + path);
            axios.post(Config.BASE_URL + path,
                body,
                { signal, headers }
            ).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
            break;
        case 'PUT':
            // Project Role-Enforcement Middleware TRD, Section 3.1 —
            // first PUT caller in this app (role-change,
            // PUT /project/:projectId/members/:userId/role). Mirrors
            // the POST case above exactly.
            axios.put(Config.BASE_URL + path,
                body,
                { signal, headers }
            ).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
            break;
        case 'DELETE':
            // First DELETE caller in this app (remove-member,
            // DELETE /project/:projectId/members/:userId). axios's
            // delete() takes the request body via config.data rather than
            // a second positional argument -- body is undefined for this
            // endpoint (projectId/userId are both in the URL) but kept
            // here for parity with the other verbs / any future caller.
            axios.delete(Config.BASE_URL + path,
                { data: body, signal, headers }
            ).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
            break;
        default:
            reject("CQAPI Manager: invalid request type");
    }
    });

    return responsePromise;
}

const attemptTokenRefresh = () => {

    const tokenPromise = new Promise((resolve, reject) => {
        
        axios.post(Config.BASE_URL + '/auth/refresh').then(() => {
            resolve();
        }).catch(err => {
            // Refresh failed (refresh_token itself missing/expired): this
            // module has no router/useNavigate access, so it can't redirect
            // to /login itself, and reaching into window.location directly
            // here would create a second, router-unaware navigation path
            // alongside the one already built in App.js. Instead, the
            // rejection below propagates up to getCMResponse's caller --
            // for the initial route-load path that's initUser() in App.js,
            // whose own .catch only fires once getCMResponse has already
            // exhausted this silent-refresh attempt. That .catch firing is
            // therefore itself the "true full session expiry, or never
            // authenticated" signal, and it's already wired to redirect to
            // /login (with redirect_url) via buildLoggedOutRedirect. No
            // additional detection logic is needed in this file.
            reject(err);
        });
    });

    return tokenPromise;
}

// Shopify-embedded-session branch of the silent-refresh-on-401 interceptor
// (TRD: docs/product/features/completed/shopify-embedded-install-auth/trd.md,
// Bounded Unit B, B3). Parallel to attemptTokenRefresh() above, which
// refreshes the CliqMetrics JWT-cookie session -- this instead re-fetches a
// FRESH App Bridge session token (never reused/cached, per the 60s token
// lifetime) and retries exactly once. If App Bridge itself can't produce a
// token (app uninstalled/access revoked), this rejects and the caller is
// responsible for rendering an in-iframe error state -- never a top-level
// redirect (B3 acceptance criteria; B4's "no navigation Shopify's CSP would
// reject" guardrail).
const attemptShopifySessionRequest = (path, requestType, body, signal) => {
    return getShopifySessionToken().then(token => {
        return pingAPI(path, requestType, body, signal, { Authorization: `Bearer ${token}` });
    });
}

const getCMResponse = (path, requestType, body, signal, options) => {
    const shopifySession = !!(options && options.shopifySession);

    if (shopifySession) {
        return new Promise((resolve, reject) => {
            attemptShopifySessionRequest(path, requestType, body, signal).then(resolve).catch(err => {
                if (axios.isCancel(err)) {
                    reject(err);
                    return;
                }
                if (err.response?.status === 401) {
                    // Single silent retry with a freshly-fetched token.
                    attemptShopifySessionRequest(path, requestType, body, signal).then(resolve).catch(retryErr => {
                        reject(retryErr);
                    });
                } else {
                    reject(err);
                }
            });
        });
    }

    const APIPromise = new Promise((resolve, reject) => {
        // console.log(path)
        pingAPI(path, requestType, body, signal).then( response => {
            resolve(response);
        }).catch( (err) => {

            if (axios.isCancel(err)) {
                reject(err);
                return;
            }

            if(err.response?.status === 500) {
                console.log('500 from server')
                reject(err)
            } else if (err.response?.status === 401) {
                attemptTokenRefresh().then(() => {
                    console.log('will reattempt ping with new token');
                    pingAPI(path, requestType, body, signal).then( response => {
                        resolve(response);
                    }).catch((retryErr) => {
                        reject(retryErr);
                    });
                }).catch((refreshErr) => {
                    reject(refreshErr);
                });
            } else {
                reject(err);
            }
        });
    });
    return APIPromise;
}

// Named wrapper for calls to `verifyShopifySession`-gated cq-api routes
// (TRD A2) -- forces the shopifySession branch above rather than requiring
// every embedded-surface call site to remember to pass options.
export const getShopifyResponse = (path, requestType, body, signal) =>
    getCMResponse(path, requestType, body, signal, { shopifySession: true });

// Thin named wrappers for the /analyze/insights surface (TRD:
// daily-insights-engine-trd.md, Section 4). No other endpoint in this
// codebase has a dedicated named wrapper -- every other call site invokes
// getCMResponse(path, method, body) directly inline -- but the TRD
// explicitly calls out these two names, so they're added here as the one
// existing API module rather than inlined at each call site, to keep the
// insights endpoints' request shape (limit/offset defaults, URL/method) in
// one place instead of duplicated across InsightsPage/InsightTile.
export const getInsights = (projectId, { limit = 10, offset = 0 } = {}) =>
    getCMResponse('/analyze/insights', 'GET', { project_id: projectId, limit, offset });

export const dismissInsight = (insightEntryId) =>
    getCMResponse(`/analyze/insights/${insightEntryId}/dismiss`, 'POST');

// Thin named wrappers for the project-wide global messages surface (TRD:
// project-global-messages-trd.md, Section 4, Requirement 2). Exact
// signature style mirrors getInsights/dismissInsight above -- same
// getCMResponse/pingAPI wrapper, same axios.defaults.withCredentials
// cookie-auth mechanism, no new HTTP client introduced.
export const getProjectMessages = (projectId) =>
    getCMResponse(`/project/${projectId}/messages`, 'GET');

export const dismissProjectMessage = (projectId, messageId) =>
    getCMResponse(`/project/${projectId}/messages/${messageId}/dismiss`, 'POST');

// TRD: dashboard-data-source-dependency-model/trd.md, Section 4.1
// Requirement 4. Backs GrantOnboardingAccess.jsx's already-built (formerly
// stubbed) Revoke-access confirmation flow. `dataSourceIds` is always an
// array -- a 1-element array for a single-provider platform tile, or every
// currently-connected Meta-provider data_sources.id for the unified Meta
// tile (Section 2.5 of the TRD) -- the backend revokes the whole batch as
// one atomic action.
export const revokeDataSources = (projectId, dataSourceIds) =>
    getCMResponse('/datasource/revoke-access', 'POST', { project_id: projectId, data_source_ids: dataSourceIds });

export default getCMResponse;